import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_APPOINTMENT_PATIENT_SOURCES_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetAppointmentPatientSourcesPayload,
  GetAppointmentPatientSourcesResult,
} from '../types/getPatientSources.types';

export const TAG_APPOINTMENT_GET_PATIENT_SOURCES = 'getPatientSources';

export const getPatientSources = <T extends BuilderType>(builder: T) =>
  builder.query<GetAppointmentPatientSourcesResult, GetAppointmentPatientSourcesPayload>({
    providesTags: [TAG_APPOINTMENT_GET_PATIENT_SOURCES],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_APPOINTMENT_PATIENT_SOURCES_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetAppointmentPatientSourcesResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
